import GoogleCalendarView from '../components/GoogleCalendarView';

export default function SchedulePage() {
  return (
    <div className="absolute inset-0 flex flex-col overflow-hidden p-4 sm:p-6">
      <GoogleCalendarView />
    </div>
  );
}
